import { useAuth0 } from '@auth0/auth0-react';
import useSWRMutation from 'swr/mutation';
import http from '@/Utils/HTTP/NewHttpUtils';

export interface LeadCapturedRequest {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    utmTerm?: string;
    utmContent?: string;
}

const useCaptureLead = () => {
    const { getAccessTokenSilently } = useAuth0();

    return useSWRMutation(
        'users/marketing/lead-captured',
        async (path: string, { arg }: { arg: LeadCapturedRequest }) => {
            await http.post({
                path,
                accessToken: await getAccessTokenSilently(),
                body: arg,
            });
        },
        {
            // best-effort side channel: lead capture must never surface as a page-level error
            onError: () => {},
        },
    );
};

export default useCaptureLead;
